module.exports = __webpack_public_path__ + "media/08knownas.e51cd34d.mp3";